import React from "react";
import BlogFortyTwo from "../component/BlogFortyTwo";

function BlogFortyTwoContainer() {
  return <BlogFortyTwo />;
}

export default BlogFortyTwoContainer;
